// Scale bridge dashboard - the TESTING result, as a tag.
//
// ─── Never colour alone ────────────────────────────────────────────────
// The tag carries an icon AND the word the label printed, so the pass/fail
// distinction survives for a colourblind reader, in greyscale print, and in
// forced-colours mode. The colours behind them are validated too - see the note
// on `success` in theme.ts - but they are the third signal, not the first.
//
// ─── An unrecognised status is never a pass ────────────────────────────
// "OK" is the pass case on the observed label. Anything else renders as a
// failure, including wording nobody has seen yet. The one time this matters is
// the day the printer's wording changes, and defaulting to green then would show
// a passing test that never happened.

import { CheckCircleFilled, CloseCircleFilled, MinusCircleOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

export default function StatusTag({ value }: { value: string | null | undefined }) {
    const text = (value ?? '').trim();

    if (text === '') {
        return (
            <Tag icon={<MinusCircleOutlined />} color="default">
                Not stated
            </Tag>
        );
    }

    const passed = /^ok$/i.test(text);
    return (
        <Tag
            icon={passed ? <CheckCircleFilled /> : <CloseCircleFilled />}
            color={passed ? 'success' : 'error'}
        >
            {text}
        </Tag>
    );
}
